(function (e, n, t, a) {
  let s,
    i = e.getElementsByTagName(n)[0],
    r = e.getElementById('universalnav-navigation');
  r.style.background = '#1f365e';
  r.style.minHeight = '36px';
  e.getElementById(t);
  s = e.createElement(n);
  s.id = t;
  s.src = 'https://download.militaryonesource.mil/MOS/universalnav.min.js';
  i.parentNode.insertBefore(s, i);
})(document, 'script', 'universalnav-js');

// google tag manager for universal nav
const passedInDataLayer2 = 'passedInDataLayer';
(function (w, d, s, l, i) {
  w[l] = w[l] || [];
  w[l].push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });
  let f = d.getElementsByTagName(s)[0],
    j = d.createElement(s),
    dl = l != 'dataLayer' ? '&l=' + l : '';
  j.async = true;
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
  f.parentNode.insertBefore(j, f);
})(window, document, 'script', passedInDataLayer2, 'GTM-N665D53');
